import React from 'react';

import { LoadingOverlay } from '@schoolinks/ui-components';
import Layout from 'components/Common/Layout';

export default () => (
  <Layout>
    <LoadingOverlay />
  </Layout>
);
